import { cn } from '@/utils/cn';

export const inputStyles = cn(
  'px-2 py-3 h-11 border-1 border-base-border rounded-md appearance-none outline-0 text-base md:text-sm font-family-sans focus:border-muted-foreground active:border-muted-foreground transition-colors duration-200'
);
